import React, { useState } from "react";
import { Modal, Button, Row, Col, Divider, Input, Form, DatePicker, Select, Switch } from "antd";
import {
  CheckOutlined,
  CloseCircleOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import "./SelectSupplierForm.css";
import moment from "moment";
import { useLocation } from "react-router-dom";

export interface SelectSupplierFormProps {
  showForm: boolean;
  editSupplierData: any;
  postSupplier: (supplierInfo: any) => void;
  postSupplierSelected: (selectedSupplier: string, selectedDate: string, isSmallTransaction: boolean) => void;
  suppliers: any[];
  openNewSupplierForm: () => void;
  // loadedPurchase: any;
}

const SelectSupplierForm = (props: SelectSupplierFormProps) => {
  const [supplierInfo, setSupplierInfo] = useState({
    name: "",
    companyName: "",
    identificationCardNumber: "",
    contactNumber: "",
    emailAddress: "",
    address: "",
    companyCode: "",
    passportNumber: "",
  });
  const [nameFormStatus, setNameFormStatus] = useState("") as any;
  const [nameFormMessage, setNameFormMessage] = useState("");
  const [companyNameFormStatus, setCompanyNameFormStatus] = useState("") as any;
  const [companyNameFormMessage, setCompanyNameFormMessage] = useState("");
  const [identificationCardNumberFormStatus, setIdentificationCardNumberFormStatus] = useState("") as any;
  const [identificationCardNumberFormMessage, setIdentificationCardNumberFormMessage] = useState("");
  const [passportFormStatus, setPassportFormStatus] = useState("") as any;
  const [passportFormMessage, setPassportFormMessage] = useState("");
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const [loadedPurchase, setLoadedPurchase] = useState({}) as any;
  const [selectedDate, setSelectedDate] = useState("");
  const [dateSelectedFormStatus, setDateSelectedFormStatus] = useState("") as any;
  const [dateSelectedFormMessage, setDateSelectedFormMessage] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [supplierSelectedFormStatus, setSupplierSelectedFormStatus] = useState("") as any;
  const [supplierSelectedFormMessage, setSupplierSelectedFormMessage] = useState("");
  const [isDateChanged, setIsDateChanged] = useState(false);
  const [supplierConfirmed, setSupplierConfirmed] = useState(false);
  const [isSmallTransaction, setIsSmallTransaction] = useState(false);
  const [isNewSupplier, setIsNewSupplier] = useState(false);
  const location = useLocation();
  const updateName = (value: any) => {
    setNameFormStatus("");
    setNameFormMessage("");
    let supplier = { ...supplierInfo };
    supplier.name = value;
    setSupplierInfo(supplier);
  };

  const updateCompanyName = (value: any) => {
    setCompanyNameFormStatus("");
    setCompanyNameFormMessage("");
    let supplier = { ...supplierInfo };
    supplier.companyName = value;
    setSupplierInfo(supplier);
  };

  const updateIdentificationCardNumber = (value: any) => {
    setIdentificationCardNumberFormStatus("");
    setIdentificationCardNumberFormMessage("");
    let supplier = { ...supplierInfo };
    supplier.identificationCardNumber = value;
    setSupplierInfo(supplier);
  };

  const updatePassportNumber = (value: any) => {
    let supplier = { ...supplierInfo };
    supplier.passportNumber = value;
    setSupplierInfo(supplier);
  };

  const updateContactNumber = (value: any) => {
    let supplier = { ...supplierInfo };
    supplier.contactNumber = value;
    setSupplierInfo(supplier);
  };

  const updateEmailAddress = (value: any) => {
    let supplier = { ...supplierInfo };
    supplier.emailAddress = value;
    setSupplierInfo(supplier);
  };

  const updateAddress = (value: any) => {
    let supplier = { ...supplierInfo };
    supplier.address = value;
    setSupplierInfo(supplier);
  };

  const updateCompanyCode = (value: any) => {
    let supplier = { ...supplierInfo };
    supplier.companyCode = value;
    setSupplierInfo(supplier);
  };

  const validateForm = () => {
    let validationFormStatus = true;
    if (isDateChanged && selectedDate === "") {
      validationFormStatus = false;
      setDateSelectedFormStatus("error");
      setDateSelectedFormMessage("Select a date");
    }
    if (selectedSupplier === "") {
      validationFormStatus = false;
      setSupplierSelectedFormStatus("error");
      setSupplierSelectedFormMessage("Select a supplier");
    }
    return validationFormStatus;
  };

  const openCancelSupplierModal = () => {
    setIsCancelModalOpen(true);
  };

  const confirmCancelSupplier = () => {
    resetSupplierInfo();
    setIsCancelModalOpen(false);
    // closeForm();
  };

  const declineCancelSupplier = () => {
    setIsCancelModalOpen(false);
  };

  const resetSupplierInfo = () => {
    setSupplierInfo({
      name: "",
      companyName: "",
      identificationCardNumber: "",
      contactNumber: "",
      emailAddress: "",
      address: "",
      companyCode: "",
      passportNumber: "",
    });
    setNameFormStatus("");
    setNameFormMessage("");
    setCompanyNameFormStatus("");
    setCompanyNameFormMessage("");
    setIdentificationCardNumberFormStatus("");
    setIdentificationCardNumberFormMessage("");
  };

  const saveSupplierInfo = () => {};

  const addSupplierInfo = () => {
    props.postSupplier(supplierInfo);
    // closeForm();
  };

  const isNewPurchaseOrNotCompleted = () => {
    return location.pathname.split("/")[2] === undefined || !loadedPurchase.completed;
  };

  const updatePurchaseDate = (dateString: string) => {
    setDateSelectedFormStatus("");
    setDateSelectedFormMessage("");
    setSelectedDate(dateString);
  };

  const updateSetIsDateChanged = () => {
    setIsDateChanged(true);
  };

  const getUpdatedDate = () => {
    const dateProperties = selectedDate.split("/");
    return new Date(`${dateProperties[2]}-${dateProperties[1]}-${dateProperties[0]}`).toLocaleDateString("en-GB");
  };

  const confirmSupplier = () => {
    props.postSupplierSelected(selectedSupplier, selectedDate, isSmallTransaction);
    setSupplierConfirmed(true);
    setIsDateChanged(false);
  };

  const formatSupplierDropdown = () => {
    if (props.suppliers === undefined || props.suppliers.length === 0) return [];
    return props.suppliers.map((supplier: any) => {
      let label = `${supplier.name}`;
      if (supplier.companyName) {
        label += ` - ${supplier.companyName}`;
      }
      if (supplier.identificationCardNumber) {
        label += ` ( IC: ${supplier.identificationCardNumber.slice(0, 6)}-${supplier.identificationCardNumber.slice(
          6,
          8
        )}-${supplier.identificationCardNumber.slice(8, 12)} )`;
      }
      if (supplier.passportNumber) {
        label += ` ( Passport: ${supplier.passportNumber} )`;
      }
      return {
        label: label,
        value: supplier.supplierID,
      };
    });
  };

  const toggleSmallTransactionFlag = (checked: boolean) => {
    setIsSmallTransaction(checked);
  };

  return props.showForm ? (
    <Row justify="center">
      <div className="select-supplier-form">
        <Row>
          <Col span={12}>
            <Row justify="start">
              <h2>Supplier Information</h2>
            </Row>
          </Col>
          <Col span={12}>
            <Row justify="end">
              {isNewPurchaseOrNotCompleted() ? (
                isDateChanged ? (
                  <Form layout="vertical">
                    <Form.Item validateStatus={dateSelectedFormStatus} help={dateSelectedFormMessage}>
                      <DatePicker
                        allowClear={false}
                        onChange={(date, dateString) => updatePurchaseDate(dateString)}
                        format={"DD/MM/YYYY"}
                        showToday
                        disabledDate={(current) => {
                          let customDate = moment().add(1, "day").format("YYYY-MM-DD");
                          return current && current > moment(customDate, "YYYY-MM-DD");
                        }}
                      />
                    </Form.Item>
                  </Form>
                ) : (
                  <>
                    {loadedPurchase.createdTimestamp !== undefined ? (
                      <h2>{new Date(loadedPurchase.createdTimestamp).toLocaleDateString("en-GB")}</h2>
                    ) : selectedDate !== "" ? (
                      <h2>{getUpdatedDate()}</h2>
                    ) : (
                      <h2>{new Date().toLocaleDateString("en-GB")}</h2>
                    )}
                    <Button
                      type="default"
                      onClick={() => updateSetIsDateChanged()}
                      icon={<EditOutlined />}
                      style={{ marginLeft: "10px" }}
                      disabled={supplierConfirmed}
                    ></Button>
                  </>
                )
              ) : (
                <h2>{new Date(loadedPurchase.createdTimestamp).toLocaleDateString("en-GB")}</h2>
              )}
            </Row>
          </Col>
        </Row>
        <Row>
          <Divider style={{ margin: "12px 0" }} />
        </Row>
        <Row justify="end">
          <Button type="default" onClick={() => props.openNewSupplierForm()} icon={<UserAddOutlined />}>
            Add New Supplier
          </Button>
        </Row>
        <Form layout="vertical">
          <Form.Item
            label={<label className="material-form-label">Select a Supplier*</label>}
            validateStatus={supplierSelectedFormStatus}
            help={supplierSelectedFormMessage}
          >
            <Select
              showSearch
              placeholder="Select a supplier"
              onChange={(value: any) => {
                setSupplierSelectedFormStatus("");
                setSupplierSelectedFormMessage("");
                setSelectedSupplier(value);
              }}
              optionFilterProp="label"
              onSearch={() => {}}
              options={formatSupplierDropdown()}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item label={<label className="material-form-label">Small Transaction</label>}>
            <Switch checked={isSmallTransaction} onChange={toggleSmallTransactionFlag} />
          </Form.Item>
        </Form>
        <Row justify="center" style={{ marginTop: "20px" }}>
          <Button type="primary" icon={<CheckOutlined />} onClick={() => validateForm() && confirmSupplier()}>
            Confirm Supplier
          </Button>
        </Row>
      </div>
      <div className="select-supplier-overlay"></div>
    </Row>
  ) : null;
};

export default SelectSupplierForm;
